export const cacheKeys = {
  users: {
    getMe: 'getMe',
  },
  surveys: {
    getSurveys: 'getSurveys',
  },
  mainSurvey: {
    getSurveyBlock: 'getSurveyBlock',
  },
  supportingInfo: {
    getSupportingInfos: 'getSupportingInfos',
    getSupportingInfo: 'getSupportingInfo',
  },
  publications: {
    getApps: 'getApps',
  },
  tags: {
    getTags: 'getTags',
    getTag: 'getTag',
  },
  existingBlocks: {
    getExistingBlocks: 'getExistingBlocks',
  },
};

export const routes = {
  login: '/login',
  surveys: '/surveys',
  survey: (id: number | string = ':surveyId') => `/surveys/${id}`,
  supportingInfos: '/supporting-information',
  tags: '/tags',
  supportingInfo: (id: number | string = ':supportingInformationId') => `/supporting-information/${id}`,
};

export const routeNames = {
  login: 'Login',
  surveys: 'Surveys',
  survey: (name: string = '') => name || 'Survey',
  supportingInfos: 'Supporting Information',
  tags: 'Tags',
  supportingInfo: (name: string = '') => name || 'Supporting Information',
}

export type Routes = keyof typeof routes;

export const routeBreadcrumbs: Record<Routes, Routes[] | null> = {
  login: null,
  surveys: null,
  survey: ['surveys'],
  supportingInfos: null,
  supportingInfo: ['supportingInfos'],
  tags: null,
};